export const domainKeys = {
  "GAMBOX CS2 Time trial leaderboard": "https://iplay-leaderboard-v2.web.app",
  "GAMEBOX Racing Forza motorsport":
    "https://iplay-leaderboard-v2.firebaseapp.com",
  "CS2 1V1 leaderboard ( light - logs)":
    "https://1v1-scoreboard-v2.web.app/tcl-light-logs",
  "CS2 1V1 leaderboard ( dark - logs )":
    "https://1v1-scoreboard-v2.web.app/tcl-logs",

  "LEGO X F1": "https://lego-ldbrd.iplay.dk/",
  "KEYCHRON TIME TRIAL": "https://keychron-ldbrd.iplay.dk/",
};
